import type React from "react"
import {
  type Currency,
  formatCurrencyBRL,
  formatCurrencyParts,
} from "../helpers/formatCurrencyBRL"
import useEnv from "../hooks/useEnv"

export const FormatCurrency: React.FC<{
  value: number | string | undefined | null
  currency?: Currency
  symbolClassName?: string
  symbolStyle?: React.CSSProperties
}> = ({ value, currency, symbolClassName, symbolStyle }) => {
  const { currency: currencyEnv } = useEnv()
  const cur = currency || currencyEnv

  // Use parts when possible to style the currency symbol only
  const parts = formatCurrencyParts(value, cur)

  if (!parts.length) {
    // Fallback to plain string
    const result = formatCurrencyBRL(value, cur)
    return <>{result}</>
  }

  return (
    <>
      {parts.map((p, idx) => {
        // TODO: Avoid using array index as key if possible. Use a unique identifier from 'p' if available.
        if (p.type === "currency") {
          return (
            <span
              key={`${p.value}-${idx}`}
              className={symbolClassName}
              style={symbolStyle}
            >
              {p.value}
            </span>
          )
        }
        return <span key={`${p.value}-${idx}`}>{p.value}</span>
      })}
    </>
  )
}

export default FormatCurrency
